import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
class Contact extends React.Component {
    render() {
        return ( <Layout>
            <SEO title="Contact" keywords={[`Contact`]} />
                <div className="contact-page page">
                    <div className="container">
                    <div className="row">
                        <div className="col-sm-12 center">
                            <div className="text-center"><h1 className="with-underline">Contact Me</h1></div>
                            <p>You may contact me here with any questions you might have. This is also where you contact me if you are near Chesterfield, MI and want to use my contact-free pick-up option to receive 20% off your order.</p>
                            <form name="Contact Form" method="POST" data-netlify="true">
                                <input type="hidden" name="form-name" value="Contact Form" />
                              <p>
                                <input type="text" name="name" placeholder="Name" />
                              </p>
                              <p>
                                <input type="email" name="email" placeholder="Email" />
                              </p>
                              <p>
                                <textarea name="message" id="message" class="c-input-field c-input-field--multiline" placeholder="Message"></textarea>
                              </p>
                              <p>
                                <button type="submit">Send</button>
                              </p>
                            </form>
                        </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}
export default Contact